import { useHeaderLayout } from '@/store/useHeaderLayout';
import { useCallback, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export const useShowHeaderCtaOnScroll = (initiallyShown?: boolean) => {
  const { ref, inView } = useInView({ initialInView: true });
  const setState = useHeaderLayout(s => s.setState);

  const showAdditionalHeaderCTA = useCallback(
    (val: boolean) => {
      setState({
        showAdditionalHeaderCTA: val,
      });
    },
    [setState],
  );

  useEffect(() => {
    setState({
      showAdditionalHeaderCTA: !inView || initiallyShown,
    });
  }, [inView, setState, initiallyShown]);

  return {
    ref,
    showAdditionalHeaderCTA,
  };
};
